module.exports = __webpack_public_path__ + "media/images/athletes/1764-de645fa233093043a28f79315c13f7aa.png";